<template>
    <div class="d-flex justify-center">
        <v-icon class="mr-2" :color="color">{{ icon }}</v-icon>
        {{ number }} {{ text }}<span v-if="number > 1">s</span>
    </div>
</template>
<script setup>
const props = defineProps({
    icon: {
        type: String,
        required: true,
    },
    color: {
        type: String,
        required: true,
    },
    number: {
        type: Number,
        required: true,
    },
    text: {
        type: String,
        required: true,
    },
})
</script>
